// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1aykr","fileBtn":"File_fileBtn__1EuWp","closeBtn":"File_closeBtn__2-NQw","fileSelected":"File_fileSelected__3vLUs","disabled":"File_disabled__3HRmb"};